import { z } from 'zod';

const boundingBoxZod = z.object({
  left_2d: z.number().int(),
  top_2d: z.number().int(),
  width_2d: z.number().int(),
  height_2d: z.number().int(),
});
export type BoundingBox = z.infer<typeof boundingBoxZod>;

export const omnitagResultItemZod = z.object({
  id: z.string(),
  timestamp: z.number().int(), // Absolute timestamp, in microseconds, for this image
  log_start_timestamp: z.number().int(), // Used to compute timestamp_in_seconds (relative to start of log) for Download CSV feature
  channel: z.string().startsWith('CAM_'),
  bounding_box: z.array(boundingBoxZod),
  track_id: z.number().int().nullable(),
  iou: z.number().nullable(),
  // track_box_2d: returned when user enables 'Query only for results with track ID' option, used to draw blue box
  track_box_2d: z.array(boundingBoxZod),
  track_type: z.string().nullable(),
  tag_probability: z.number(),
  log_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  log_name: z.string(),
  route_name: z.string(),
  city: z.string(),
  test_type: z.string(),
  test_sub_type: z.string(),
  software_version: z.string(),
  sun_lighting_condition: z.string(),
  weather_condition: z.string(),
  distance_to_ego: z.number().optional(), // Temporarily optional, while we wait for backend to add this (as of Sep 2025)
  ego_location: z.string().optional(),
  surface_type: z.string().optional(),
  extraction_token: z.string().nullable().optional(),
});

export const omnitagSearchResponseZod = z.object({
  imageMetadata: z.array(omnitagResultItemZod),
});

export type OmnitagSearchResp = z.infer<typeof omnitagSearchResponseZod>;
export type OmnitagResultItem = z.infer<typeof omnitagResultItemZod>;
export type OmnitagBBoxType = z.infer<typeof boundingBoxZod>;

export const omnitagSearchSizeResponseZod = z.object({
  count: z.number(),
});
export type OmnitagSearchSizeResp = z.infer<
  typeof omnitagSearchSizeResponseZod
>;
